import { graphql } from "relay-runtime"

export const chFindClosestPreventionCareProviderMutation = graphql`
  mutation chFindClosestPreventionCareProviderMutation($input: Ch_findClosestPreventionCareProviderInput!) {
    ch_findClosestPreventionCareProvider(input: $input) {
      findClosestPreventionCareProviderOutput {
        closestCareProviderId
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
